import { render, staticRenderFns } from "./use-goods-list.vue?vue&type=template&id=534474fa&scoped=true&"
import script from "./use-goods-list.vue?vue&type=script&lang=js&"
export * from "./use-goods-list.vue?vue&type=script&lang=js&"
import style0 from "./use-goods-list.vue?vue&type=style&index=0&id=534474fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534474fa",
  null
  
)

export default component.exports